export enum DatiqTooltipTypes {
    Info = 'Info',
}
